// extracted by mini-css-extract-plugin
module.exports = {"button":"ScrollTop_button__3f0Oc","MoveUpDown":"ScrollTop_MoveUpDown__DKv3m"};